export default {
  type: 'roles',
  name: 'Role',
  permissions: {
    view: { app: 'people', role: 'people' },
    insert: { app: 'people', role: 'people' },
    update: { app: 'people', role: 'people' },
    delete: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allRoles',
    orderBy: {
      type: 'RolesOrderBy',
      default: 'ROLE_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'roleName',
        searchable: false,
        order: 'ROLE_NAME'
      },
      {
        name: 'roleTitle',
        searchable: false,
        order: 'ROLE_TITLE'
      },
      {
        alias: 'numberOfMembers',
        searchable: false,
        join: 'rolePeopleByRoleName',
        fields: ['totalCount'],
        searchType: 'modal'
      },
      {
        alias: 'members',
        searchable: false,
        searchType: 'form',
        join: 'rolePeopleByRoleName',
        nodes: true,
        fields: [
          {
            join: 'personByPersonId',
            fields: ['fullName']
          }
        ]
      },
      {
        name: 'orgPlan',
        type: 'boolean',
        searchable: false,
        searchType: 'form'
      },
      {
        alias: 'usedInGroups',
        searchable: false,
        showResults: false,
        searchType: 'form',
        join: 'groupRolesByRoleName',
        nodes: true,
        fields: [
          {
            join: 'groupByGroupId',
            fields: ['groupName']
          }
        ]
      },
      {
        alias: 'usedInEmailLists',
        searchable: false,
        showResults: false,
        searchType: 'form',
        join: 'groupRolesByRoleName',
        nodes: true,
        fields: [
          {
            join: 'groupByGroupId',
            fields: [
              {
                join: 'groupEmailsByGroupId',
                nodes: true,
                fields: ['emailList']
              }
            ]
          }
        ]
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'roleName',
        required: true
      },
      'roleTitle',
      'parentRole',
      'roleDescription',
      {
        field: 'orgPlan',
        type: 'Boolean',
        required: true,
        default: false
      },
      'supportEmail'
    ],
    key: ['roleName'],
    input: 'role',
    create: 'createRole',
    delete: 'deleteRole',
    update: 'updateRole'
  },
  load: {
    nodeId: 'role',
    key: 'roleByRoleName'
  },
  form: {
    createHeader: 'Create Role',
    editHeader: 'Edit Role - ${roleName}',
    printHeader: 'Role - ${roleName}',
    schema: [
      {
        name: 'roleName',
        labelWidth: 2,
        required: true
      },
      {
        name: 'roleTitle',
        labelWidth: 2
      },
      {
        name: 'roleDescription',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        name: 'parentRole',
        labelWidth: 2,
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allRoles',
          value: 'roleName',
          text: 'roleName'
        }
      },
      {
        name: 'orgPlan',
        labelWidth: 2,
        type: 'checkbox'
      },
      {
        name: 'supportEmail',
        labelWidth: 2,
        placeholder: 'Optional'
      }
    ],
    audit: {
      lookup: 'allPersonAudits',
      orderBy: { type: 'PersonAuditsOrderBy', value: 'EVENT_TIME_ASC' },
      dbTableHeaders: [
        {
          value: 'role_people',
          header: 'Person:',
          headerField: 'personNameAccount'
        },
        { value: 'group_role', header: 'Group:', headerField: 'groupName' }
      ]
    }
  },
  joinTables: [
    {
      label: 'Members',
      addLabel: 'Add Member',
      removeLabel: 'Remove ${personByPersonId.fullName} from this role?',
      lookup: 'allRolePeople',
      join: 'personByPersonId',
      fields: [
        { field: 'personId', name: 'personId', type: 'Int', required: true },
        { name: 'fullName', label: 'Name' },
        'affiliation'
      ],
      route: {
        name: 'personEdit'
      },
      searchFilters: {
        statusCode: {
          in: {
            type: 'StringArray',
            array: true,
            required: true,
            default: '["A","F"]'
          }
        }
      },
      create: 'createRolePerson',
      delete: 'deleteRolePerson',
      input: 'rolePerson',
      update: 'updateRolePerson',
      formType: 'people',
      multiHeader: 'Added ${fullName} to role',
      options: [
        {
          field: 'acting'
        }
      ]
    },
    {
      label: 'Owner/Admin Applications',
      addLabel: 'Add Applicaiton',
      removeLabel: 'Remove ${applicationByApplicationId.name} from this role?',
      lookup: 'allApplicationRoles',
      join: 'applicationByApplicationId',
      fields: [
        {
          field: 'applicationId',
          type: 'Int',
          required: true,
          show: false
        },
        { field: 'applicationName', alias: 'name' },
        { field: 'applicationDesc', alias: 'description' },
        {
          field: 'applicationId',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'applications'
        }
      },
      create: 'createApplicationRole',
      delete: 'deleteApplicationRole',
      input: 'applicationRole',
      formType: 'applications',
      multiHeader: 'Added ${applicationName} to role'
    }
  ]
}
